import { BusinessBillingAlert } from '../../../types/businessApi';

/**
 * Why a read-only business is read-only, as far as THIS viewer has been told.
 *
 *  - `paused`: the billing alert says the group's own card subscription is
 *    paused. It has not ended, so "lapsed" would be false.
 *  - `lapsed`: the alert says it lapsed, or nothing explains it to the OWNER.
 *    The owner is sent every billing alert there is, so a read-only owner with
 *    none is a lapse the alert does not cover (a RevenueCat Business that
 *    ended, a group that never subscribed, an older api).
 *  - `null`: anything else. A member the api tells nothing, or an alert that
 *    is neither, cannot be told "lapsed", because the books may be read-only
 *    because of a pause; say read-only and no more.
 *
 * Asked only of a business that IS read-only: it says why, never whether.
 */
export type ReadOnlyReason = 'paused' | 'lapsed' | null;

export const readOnlyReason = (
  isOwner: boolean,
  alert: BusinessBillingAlert | null | undefined
): ReadOnlyReason => {
  if (alert?.status === 'paused') return 'paused';
  if (alert?.status === 'lapsed') return 'lapsed';
  if (!alert && isOwner) return 'lapsed';
  return null;
};
